<template>
  <el-container class="doc" direction='vertical'>
   <div class="search-container">
      <div class="v-search-btn">
        <el-date-picker value-format="yyyy-MM-dd" class="v-date" v-model="valuedate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="clickSearch" size="medium">查询</el-button>
      </div>
    </div>
    <el-container direction='vertical' class="mian-container">
      <div class="scrollbar-container">
        <el-scrollbar>
          <el-table :data="tableData" stripe highlight-current-row>
            <el-table-column align="center" label="实体卡号">
              <template slot-scope="scope">
                <span>{{ scope.row.physicalcard_cardno }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" width="250px" label="会员名称">
              <template slot-scope="scope">
                <span>{{ scope.row.physicalcard_nickname || scope.row.physicalcard_name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="手机号">
              <template slot-scope="scope">
                <span>{{ scope.row.physicalcard_mobile }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="扣款金额">
              <template slot-scope="scope">
                <span>{{ scope.row.amount }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="扣款余额">
              <template slot-scope="scope">
                <span>{{ scope.row.balance }} </span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="扣款时间">
              <template slot-scope="scope">
                <span>{{ scope.row.createtime }} </span>
              </template>
            </el-table-column>
          </el-table>
        </el-scrollbar>
      </div>
      <el-pagination @current-change="currentChange" background v-if="total>20" :page-size="pageSize" layout="prev, pager, next" :current-page="page"  :total="total">
      </el-pagination>
    </el-container>
  </el-container>
</template>
<script>
import { recordsList } from '@/views/webpc/CashierDesk/CardManagementApp/apis'
export default {
  data () {
    return {
      pageSize: 20,
      page: 1,
      total: 0,
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      valuedate: null,
      tableData: []
    }
  },
  methods: {
    // 验证记录
    loadData () {
      this.isLoading = true
      this.tableData = []
      let data = new FormData()
      data.append('page', this.page)
      data.append('size', this.pageSize)
      if (this.valuedate) {
        data.append('startdate', this.valuedate[0])
        data.append('enddate', this.valuedate[1])
      }
      recordsList(data)
        .then(result => {
          if (result) {
            this.isLoading = false
            this.tableData = result.data.list
            this.total = result.data.pager.records
          }
        }).catch(error => {
          if (error) {
            this.isLoading = false
          }
        })
    },
    // 分页
    currentChange (val) {
      this.page = val
      this.loadData()
    },
    clickSearch () {
      this.page = 1
      this.loadData()
    }
  },
  mounted () {
    this.loadData()
  },
  created () {
  }
}
</script>



// WEBPACK FOOTER //
// src/views/webpc/CashierDesk/CardManagementApp/CardManagementRecords.vue